import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { fetchVenue } from 'apis/restaurant-api/merchant-admin/venue/api';

import { ExperienceEntity, ExperienceEntityType } from '../types';

export const useVenue = (identifier: string, isVenueFetchEnabled = true) => {
  const {
    data: venue,
    error,
    isLoading,
  } = useQuery(
    ['/v1/merchant-admin/venues/', identifier],
    () => {
      return identifier ? fetchVenue(identifier) : undefined;
    },
    {
      enabled: isVenueFetchEnabled,
      refetchOnWindowFocus: false,
    },
  );

  const experienceEntity: ExperienceEntity | null = useMemo(() => {
    if (!venue) {
      return null;
    }
    return {
      experienceEntityId: venue.id,
      experienceEntityType: ExperienceEntityType.VENUE,
      experienceEntityObject: venue,
    };
  }, [venue]);

  const experienceEntityTree = useMemo(() => {
    if (!experienceEntity) {
      return null;
    }
    return {
      experienceEntity,
      children: [],
    };
  }, [experienceEntity]);

  return { experienceEntity, experienceEntityTree, error, isLoading };
};
